﻿//@ts-nocheck

//nvm use 18.13.0
//build
//cd Scripts
//yarn build:watch

//import scope from 'babel-plugin-console/scope.macro'

var SelectedLang;
var JSAllDictionaryItems = {};
var kioskNumBoxNum;
var BoxesStatus;
var OperationMode='';
var CustomerCredentials;
var helpModal;
var collectModal;
var hotlineModal;
var collectModalTimer;
var hotlineModalTimer;
var KioskId;
var TotalKiosks;
var TotalBoxes;
var CourierPassword;
var ViewBagDebug;
var ViewBagTestMode;
var ViewBagUpdateMode;
var CurrentPage = '';
const MaxDoorCheckTime = 60; //60sec
var CountDown = 0;
var csLockControlResponse;
var kioskName;
var keylist = '';
var VisitorMobile = '';
var port;
var CountDownTimer;
var focusInputActive = true;
var UmbracoGetDictionaryValue = {};
var doorAlertCancel = true;
var collectCheckIfDoorCloseCount = 0;
var collectCheckIfDoorCloseTime = performance.now();
var checkIfDoorOpenCount = 0;
var checkIfDoorOpenTime = performance.now();
var checkIfDoorCloseCount = 0;
var checkIfDoorCloseTime = performance.now();
var courierStep = 10;
var doorChecking = false;
var ReservedTotal = 0;
var ExpiredTotal = 0;
var MonitorData = {};
var ReOpenMode = false;
var HandicappedMode = false;
var QrcodeRunMode = false;
var QrcodeText = '';
var SelectedBox = 0;
var Token='';
var UserId = 3;
var LockerId = '1';
var Location = '大厅';
var BoxNumbber = '1';
var Passcode = '';
var Recipients = '';
//@hf:use private IP for production
//var WMSAPIIP = 'https://ricoh2023.rd.virsical.cn';
var WMSAPIIP = 'http://172.28.54.67';

var collectBoxList = [];
var CollectBoxList = [];
var doorAlertIndex = 0;
var doorStatus = {};
var helpModalTimer = null;
var CourierReservedState = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
var CourierExpiredState = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
var CustomerCollectCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var expiredTimerId = null;
var countdownTimerId = null;
var pcfocusInputTimerId = null;
var doQrcodeTimerId = null;

async function init_script(kioskId, courierPw, vdebug, vtestmode, vupdatemode, kioskNo, totalBoxes) {
    console.log('init_script', kioskId, courierPw, vdebug, vtestmode, vupdatemode, kioskNo, totalBoxes);
    //@hfa
    if (kioskId == 'OFFICE2') {
        //WMSAPIIP = 'https://uat.rd.virsical.cn';
        WMSAPIIP = 'https://cloud.virsical.cn';
    }
    console.log('WMSAPIIP', WMSAPIIP);
    KioskId = kioskId;
    CourierPassword = courierPw;
    ViewBagDebug = vdebug == 'True';
    ViewBagTestMode = vtestmode == 'True';
    ViewBagUpdateMode = vupdatemode == 'True';
    TotalKiosks = kioskNo;
    TotalBoxes = totalBoxes;

    MonitorData.kiosk_id = KioskId;
    MonitorData.status = '';
    MonitorData.temperature = '';
    MonitorData.control_status = '';
    MonitorData.alarm = '';

    await dotnetJSConsole('JsConsole:' + KioskId, 'Smart Office version 3', KioskId, null, null, null)

            if (expiredTimerId != null) clearTimeout(expiredTimerId);
            expiredTimerId = setTimeout(() => {
                doExpireTimer();
            }, 5000);

            await delay(3000);
            await goHomePage();

}

function init_language(PleaseDeliverParcel,
    IncorrectBarcodePleaseScanTheBarcodeAgain,
    CollectParcelCompletedTapHereToContinue,
    PleaseCollectParcel,
    RemainingDeliverItemsAndTotalDeliverItems,
    PleaseScanDeliverParcelBarcode,
    DeliverParcelCompletedTapHereToExit,
    NoParcelNeededToCollectOrDeliver,
    NoParcelNeededToCollect
) {
    UmbracoGetDictionaryValue['PleaseDeliverParcel'] = PleaseDeliverParcel;
    UmbracoGetDictionaryValue['IncorrectBarcodePleaseScanTheBarcodeAgain'] = IncorrectBarcodePleaseScanTheBarcodeAgain;
    UmbracoGetDictionaryValue['CollectParcelCompletedTapHereToContinue'] = CollectParcelCompletedTapHereToContinue;
    UmbracoGetDictionaryValue['PleaseCollectParcel'] = PleaseCollectParcel;
    UmbracoGetDictionaryValue['RemainingDeliverItemsAndTotalDeliverItems'] = RemainingDeliverItemsAndTotalDeliverItems;
    UmbracoGetDictionaryValue['PleaseScanDeliverParcelBarcode'] = PleaseScanDeliverParcelBarcode;
    UmbracoGetDictionaryValue['DeliverParcelCompletedTapHereToExit'] = DeliverParcelCompletedTapHereToExit;
    UmbracoGetDictionaryValue['NoParcelNeededToCollectOrDeliver'] = NoParcelNeededToCollectOrDeliver;
    UmbracoGetDictionaryValue['NoParcelNeededToCollect'] = NoParcelNeededToCollect;
}

//@hf:control box clicked
async function boxNum(num) {
    console.log('boxNum', num);

    let boxesStatuslist = BoxesStatus.split(',');
    boxesStatuslist[num-1] = '';
    localStorage.setItem('boxStatus', boxesStatuslist.join(','));
    //@hfa
    BoxesStatus = boxesStatuslist.join(',');

    await doOpenBox(num);

    dispBoxStatus();
}

//actual invoke here
async function _invokeCSharpAction(hex) {
    //@@hf: you may add false & for actual testing
    if (ViewBagTestMode == true || ViewBagDebug == true) {
        console.log('invokeCSharpAction simulation', hex);
        let num = Math.floor(Math.random() * 10); //0-9
        if (num < 3)  //reserved:1, expired:8
            csLockControlResponse = '010402000178f0';
        else
            csLockControlResponse = '010402000078f0';
        await delay(250);
    } else {
        csLockControlResponse = '';
        await delay(10);
        await invokeCSharpAction(hex);
        await delay(250);
    }
}

function heatcrc16(buffer) {
    var crc = 0xFFFF;
    var odd;

    for (var i = 0; i < buffer.length; i++) {
        //console.log(i,buffer[i].toString(16))
        crc = crc ^ buffer[i];

        for (var j = 0; j < 8; j++) {
            odd = crc & 0x0001;
            crc = crc >> 1;
            if (odd) {
                crc = crc ^ 0xA001;
            }
        }
    }

    return crc;
};


async function myTest() {
    let _kiosk = 1;
    let _box = 1;
    //    console.log('doOpenBox kioskNumBoxNum', kioskNumBoxNum)
    console.log('doOpenBox num,kiosk,box', num, _kiosk, _box)
    //let unitNum = parseInt((num - 1) / 8) + 1;
    try {
        //let data = [0x01, 0x04, 0x9c, 0x58, 0x00, 0x01];
        let data = [0x01, 0x06, 0x75, 0x9b, 0x00, 0x00];
        let crc = heatcrc16(data);
        console.log('crc16', crc);
        const crc1 = crc & 0xff;
        const crc2 = crc >>8;
        let data2 = [0x01, 0x04, 0x9c, 0x58, 0x00, 0x01, crc1,crc2];
        console.log('doOpenBox', num, data2);

        let hex = data2.map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
        console.log('after doOpenBox', hex)
    }
    catch (ex) {
        console.log('doOpenBox ex', ex);
    }
}

async function doOpenBox(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
//    console.log('doOpenBox kioskNumBoxNum', kioskNumBoxNum)
    console.log('doOpenBox num,kiosk,box', num,_kiosk, _box)
    //let unitNum = parseInt((num - 1) / 8) + 1;
    try {
        //let data = Uint8Array.from([1, 6, 0, 0x3B + num - 1, 00, 01])
        let data = [0x8a, _kiosk, _box, 0x11];
        let crc = crc16(data);
        console.log('crc', crc);
        let data2 = [0x8a, _kiosk, _box, 0x11, crc];
        console.log('doOpenBox', num, data2);

        let hex = data2.map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
        console.log('after doOpenBox',hex)
    }
    catch (ex) {
        console.log('doOpenBox ex',ex);
    }
}

async function doOpenAllBox() {
    console.log('doOpenAllBox12')
    //let unitNum = parseInt((num - 1) / 8) + 1;
    try {
        //let data = Uint8Array.from([1, 6, 0, 0x3B + num - 1, 00, 01])
        let data = [0x8a, 1, 0, 0x11];
        let crc = crc16(data);
        console.log('crc', crc);
        let data2 = [0x8a, 1, 0, 0x11, crc];
        console.log('doOpenAllBox1', data2);

        let hex = data2.map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
        console.log('after doOpenAllBox1', hex)
    }
    catch (ex) {
        console.log('doOpenAllBox1 ex', ex);
    }
    try {
        //let data = Uint8Array.from([1, 6, 0, 0x3B + num - 1, 00, 01])
        let data = [0x8a, 2, 0, 0x11];
        let crc = crc16(data);
        console.log('crc', crc);
        let data2 = [0x8a, 2, 0, 0x11, crc];
        console.log('doOpenAllBox2', data2);

        let hex = data2.map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
        console.log('after doOpenAllBox2', hex)
    }
    catch (ex) {
        console.log('doOpenAllBox2 ex', ex);
    }
}

async function doQrcodeTest() {
    QrcodeRunMode = true;
    await doQrcode();
}

async function doQrcode() {
    //@hf
    //console.log('doQrcode', QrcodeRunMode);
    if (!QrcodeRunMode) return;
    if (KioskId == "TEST_KIOSK" || KioskId == "test_kiosk") {
        try {
            let hex = 'Qrcode:get'
            await _invokeCSharpAction(hex);
        }
        catch (ex) {
            //console.log('doQrcode ex', ex);
        }

        if (doQrcodeTimerId != null) clearTimeout(doQrcodeTimerId);
        doQrcodeTimerId = setTimeout(doQrcode, 400);
        //    await delay(333);
        //    await doQrcode();
    }

}

async function updateQrcode(text) {
    if (text != '') {
        console.log('updateQrcode:', text);
        QrcodeText = text;
        keylist = text;
        let qrcode = document.getElementById("qrCodeText");
        if (qrcode != null) qrcode.innerHTML = text;

        doCollect();
    }
}

function dispBoxStatus() {
    //let boxStatusText = document.getElementById("boxStatusText");
    //if (boxStatusText != null) boxStatusText.innerHTML = '(' + BoxesStatus + ')';
    let status = BoxesStatus.split(',');

    for (let i = 1; i <= 10; i++) {
        document.getElementById("ctrMsgBox" + i).innerHTML = status[i-1].slice(-10);
    }
}

function clearBoxStatus() {
    console.log('clearBoxStatus:', BoxesStatus);
    const status = ',,,,,,,,,'
    localStorage.setItem('boxStatus', status);
    BoxesStatus = status;
    let boxStatusText = document.getElementById("boxStatusText");
    if (boxStatusText != null) boxStatusText.innerHTML = '';
    dispBoxStatus();
}

//not use
async function readLockStatus(num) {
    try {
        let data = Uint8Array.from([1, 4, 0, 0x13 + num - 1, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([1, 4, 0, 0x13 + num - 1, 0, 1, crc]);
        //console.log('readLockStatus', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readLockStatus ex:', ex);
    }

}

//Door actual status: 0:open, 1:closed
async function readDoorStatus(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
    console.log('readDoorStatus kiosk,box', _kiosk, _box)
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, 0x27 + _box - 1, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, 0x27 + _box - 1, 0, 1, crc]);
        //console.log('readDoorStatus', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readDoorStatus ex:', ex);
    }

}

//Door alert status: 00:normal, else:error
async function readDoorAlert(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
    console.log('readDoorAlert kiosk,box', _kiosk, _box)
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, 0x3B + _box - 1, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, 0x3B + _box - 1, 0, 1, crc]);
        //console.log('readDoorAlert', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readDoorAlert ex:', ex);
    }

}

//LED status: 0:off, 1:on
async function readDoorLED(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
    console.log('readDoorLED kiosk,box', _kiosk, _box)
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, 0x4F + _box - 1, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, 0x4F + _box - 1, 0, 1, crc]);
        //console.log('readDoorLED', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readDoorLED ex:', ex);
    }

}

//0:normal, 1:abnormal
//eg 0104020000b930
async function readRefriCommStatus(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
    console.log('readRefriCommStatus kiosk,box', _kiosk, _box)
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, 0x68, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, 0x68, 0, 1, crc]);
        //console.log('readRefriCommStatus', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readRefriCommStatus ex:', ex);
    }

}

//0:normal, 1:abnormal
async function readBoardCommStatus(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
    console.log('readBoardCommStatus kiosk,box', _kiosk, _box)
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, 0x69, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, 0x69, 0, 1, crc]);
        //console.log('readBoardCommStatus', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readBoardCommStatus ex:', ex);
    }

}

async function readTempSensor(_kiosk, _sensor) {
    //let kb = kioskNumBoxNum[num - 1].split(',');
    //let _kiosk = +kb[0];
    //let _box = +kb[1];
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, _sensor - 1, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, _sensor - 1, 0, 1, crc]);
        console.log('readTempSensor', _kiosk, _sensor);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readTempSensor ex:', ex);
    }

}


//lock status: 0:closed, 1:open, 2:error
async function readDoorLock(num) {
    let kb = kioskNumBoxNum[num - 1].split(',');
    let _kiosk = +kb[0];
    let _box = +kb[1];
    console.log('readDoorLock kiosk,box', _kiosk, _box)
    try {
        let data = Uint8Array.from([_kiosk, 4, 0, 0x13 + _box - 1, 0, 1]);
        let crc = crc16(data);
        let data2 = new Uint8Array([_kiosk, 4, 0, 0x13 + _box - 1, 0, 1, crc]);
        //console.log('readDoorLock', data2);
        let hex = Array.from(data2).map(i2hex).join('');
        csLockControlResponse = '';
        await _invokeCSharpAction(hex);
    }
    catch (ex) {
        console.log('readDoorLock ex:', ex);
    }
}

async function readSingleDoorStatus(boxNo) {
    await readDoorStatus(boxNo);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleDoorStatus1', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        //e.g. 010402000178f0
        let state = csLockControlResponse.substr(8, 2);
        //0:open, 1:closed actually
        if (parseInt(state, 16) == 0x00) {
            console.log('readSingleDoorStatus opened', state);
            csLockControlResponse = '';
            return 'opened';
        } else if (parseInt(state, 16) == 0x01) {
            console.log('readSingleDoorStatus closed', state);
            csLockControlResponse = '';
            return 'closed';
        }
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleDoorLED(boxNo) {
    await readDoorLED(boxNo);
    for (let j = 0; j <= 20; j++) {
        if (csLockControlResponse != '') break;
        await wait(30);
        console.log('readSingleDoorLED1', csLockControlResponse);
    }
    if (csLockControlResponse.length == 14) {
        //e.g. 010402000178f0
        let state = csLockControlResponse.substr(8, 2);
        //0:off, 1:on
        if (parseInt(state, 16) == 0x00) {
            console.log('readSingleDoorLED off', state);
            csLockControlResponse = '';
            return 'off';
        } else if (parseInt(state, 16) == 0x01) {
            console.log('readSingleDoorLED on', state);
            csLockControlResponse = '';
            return 'on';
        }
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleDoorLock(boxNo) {
    await readDoorLock(boxNo);
    for (let j = 0; j <= 20; j++) {
        if (csLockControlResponse != '') break;
        await wait(30);
        console.log('readSingleDoorLock', csLockControlResponse);
    }
    if (csLockControlResponse.length == 14) {
        //e.g. 010402000178f0
        let state = csLockControlResponse.substr(8, 2);
        //0:off, 1:on
        if (parseInt(state, 16) == 0x00) {
            console.log('readSingleDoorLock off', state);
            csLockControlResponse = '';
            return 'off';
        } else if (parseInt(state, 16) == 0x01) {
            console.log('readSingleDoorLock on', state);
            csLockControlResponse = '';
            return 'on';
        }
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleControlTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 1);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleControlTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleControlTempSensor state', state);
        let temp = parseInt(state, 16);
        if (temp >= 128) {
            temp = temp - 256;
        }
        console.log('readSingleControlTempSensor temp', temp);
        return temp;
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleDefrostTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 2);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleDefrostTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleDefrostTempSensor state', state);
        let temp = parseInt(state, 16);
        if (temp >= 128) {
            temp = temp - 256;
        }
        console.log('readSingleDefrostTempSensor temp', temp);
        return temp;
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleCompressorTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 3);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleCompressorTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleCompressorTempSensor state', state);
        let temp = parseInt(state, 16);
        if (temp >= 128) {
            temp = temp - 256;
        }
        console.log('readSingleCompressorTempSensor temp', temp);
        return temp;
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleDisplayTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 4);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleDisplayTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleDisplayTempSensor state', state);
        let temp = parseInt(state, 16);
        if (temp >= 128) {
            temp = temp - 256;
        }
        console.log('readSingleDisplayTempSensor temp', temp);
        return temp;
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleLoopTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 5);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleLoopTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleLoopTempSensor state', state);
        let temp = parseInt(state, 16);
        if (temp >= 128) {
            temp = temp - 256;
        }
        console.log('readSingleLoopTempSensor temp', temp);
        return temp;
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleStatusTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 6);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleStatusTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleStatusTempSensor state', state);
        return state;
    }

    csLockControlResponse = '';
    return '';
}

async function readSingleAlarmTempSensor(_kiosk) {
    await readTempSensor(_kiosk, 8);
    for (let j = 0; j <= 20; j++) {
        console.log('readSingleAlarmTempSensor', csLockControlResponse);
        if (csLockControlResponse != '') break;
        await wait(30);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        console.log('readSingleAlarmTempSensor state', state);
        return state;
    }

    csLockControlResponse = '';
    return '';
}


async function readAllDoorStatus() {
    const totalBox = 24;
    document.getElementById("errorTextBox").innerHTML = '';
    document.getElementById("errorTextBox2").innerHTML = '';

    for (let i = 1; i <= totalBox; i++) {
        await readDoorStatus(i);
        for (let j = 0; j <= 40; j++) {
            if (csLockControlResponse != '') break;
            await wait(60);
            console.log('readAllDoorStatus1', csLockControlResponse);
        }
        if (csLockControlResponse.length == 14) {
            //e.g. 010402000178f0
            let state = csLockControlResponse.substr(8, 2);
            console.log('state1', state);
            //0:open, 1:closed actually
            if ((parseInt(state, 16) & 0x01) == 0x00)
                document.getElementById("ctrBox" + i).style.backgroundColor = 'yellow';
            else
                document.getElementById("ctrBox" + i).style.backgroundColor = 'grey';
        }
        else {
            document.getElementById("ctrBox" + i).style.backgroundColor = 'orange';
        }
    }

    for (let i = 1; i <= totalBox; i++) {
        await readDoorAlert(i);
        for (let j = 0; j <= 40; j++) {
            console.log('readAllDoorStatus2', csLockControlResponse);
            if (csLockControlResponse != '') break;
            await wait(60);
        }
        if (csLockControlResponse.length == 14) {
            let state = csLockControlResponse.substr(8, 2);
            //console.log('state2', state);
            //0:normal
            if (parseInt(state, 16) != 0x00)
                document.getElementById("ctrBox" + i).style.backgroundColor = 'red';
        }
        else {
            document.getElementById("ctrBox" + i).style.backgroundColor = 'orange';
        }
    }

    let msg = 'readDoorLED\n';
    for (let i = 1; i <= totalBox; i++) {
        await readDoorLED(i);
        for (let j = 0; j <= 40; j++) {
            if (csLockControlResponse != '') break;
            await wait(60);
            console.log('readAllDoorStatus3', csLockControlResponse);
        }
        if (csLockControlResponse.length == 14) {
            let state = csLockControlResponse.substr(8, 2);
            console.log('state3', state);
            //0:normal
            //            if (parseInt(state, 16) != 0x00)
            //                document.getElementById("ctrBox" + i).style.backgroundColor = 'red';

            msg += csLockControlResponse.substr(8, 2) + '\n';
        }
    }
    document.getElementById("errorTextBox").innerHTML = msg;

    msg = 'readDoorLock\n';
    for (let i = 1; i <= totalBox; i++) {
        await readDoorLock(i);
        for (let j = 0; j <= 40; j++) {
            if (csLockControlResponse != '') break;
            await wait(60);
            console.log('readAllDoorStatus4', csLockControlResponse);
        }
        if (csLockControlResponse.length == 14) {
            let state = csLockControlResponse.substr(8, 2);
            console.log('state4', state);
            //0:normal
            //            if (parseInt(state, 16) != 0x00)
            //                document.getElementById("ctrBox" + i).style.backgroundColor = 'red';

            msg += csLockControlResponse.substr(8, 2) + '\n';
        }
    }
    document.getElementById("errorTextBox2").innerHTML = msg;

}
//-----
//https://linuxhint.com/send-post-request-xmlhttprequest-javascript/
function networkTest22() {
    console.log('networktest2');
    const url = `${WMSAPIIP}/vsk/vst-visitor/api/whiteList/lockerScanCodeCallback?qrCodeContent=INVITA_358478`;

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            console.log('networktest3', this.readyState,this.status);
            if (this.readyState == 4 && this.status == 200) {
                console.log('responseText', this.responseText);
                resolve(this.responseText);
            }
        };
        xhttp.open("POST", url);
        xhttp.send();
    });

}

//NOTE: get access token
function getAccessToken() {
    const url = `${WMSAPIIP}/vsk/virsical-auth/oauth/token?grant_type=client_credentials`;
    console.log('getAccessToken',url);

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            console.log('getAccessToken', this.readyState, this.status);
            if (this.readyState == 4 && this.status == 200) {
                console.log('responseText', this.responseText);
                try {
                    const res = JSON.parse(this.responseText);
                    resolve(res);
                } catch (err) {
                    resolve({code:-1,msg:'Network issue1'});
                }
            }
        };
        xhttp.open("GET", url);
        if (KioskId == 'OFFICE2') {
//            xhttp.setRequestHeader("Authorization", "Basic Y2xpZW50MTcwNTg5MjU0ODU0NTg3NTQxMTc3OjM3OTQyMDcwLTJhMDAtNGI4Mi04NDE1LTcyOTU5ODNiMGFlOA==");
            //production 
            xhttp.setRequestHeader("Authorization", "Basic Y2xpZW50MTcwODMyODI3OTkwMzI5NjUyNjY0OjE5YzQwYjE5LThmNTktNDNiNy05ZGVmLTkwZGNiODI0NDMwNg==");
        } else {
            xhttp.setRequestHeader("Authorization", "Basic Y2xpZW50MTY4NTQxODQwOTkzMTU4NTY5Nzk1OjhlMmRjMWMyLTIyYzYtNDc0Ny04MDYzLTY4ODQ1MGUzYTAyNg==");
        }
        xhttp.send();
    });

}

//NOTE: qrcodeVerify
function qrcodeVerify(token, qrCode) {
    console.log('qrcodeVerify');
    const url = `${WMSAPIIP}/vsk/smartaccess/third/thirdQrCode/validateQrCode`;

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            console.log('qrcodeVerify', this.readyState, this.status);
            if (this.readyState == 4 && this.status == 200) {
                console.log('responseText', this.responseText);
                try {
                    const res = JSON.parse(this.responseText);
                    resolve(res);
                } catch (err) {
                    resolve({ code: -1, msg: 'Network issue2' });
                }
            }
        };
        xhttp.open("POST", url);
        xhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhttp.setRequestHeader("Authorization", "bearer " + token);
        const body = {
            "qrCode": qrCode
        };
        xhttp.send(JSON.stringify(body));
    });

}

function lockerCallback(token) {
    console.log('lockerCallback',token);
    const url = `${WMSAPIIP}/vsk/vst-visitor/api/third/lockerCallback`;
    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            console.log('lockerCallback', this.readyState, this.status);
            if (this.readyState == 4 && this.status == 200) {
                console.log('responseText', this.responseText);
                try {
                    const res = JSON.parse(this.responseText);
                    resolve(res);
                } catch (err) {
                    resolve({ code: -1, msg: 'Network issue3' });
                }
            }
        };
        xhttp.open("POST", url);
        xhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhttp.setRequestHeader("Authorization", "bearer " + token);
        const body = {
            "userId": UserId,
            "lockerId": LockerId,
            "location": Location,
            "boxNumber": BoxNumbber,
            "passcode": Passcode,
            "recipients": Recipients,
        };
        console.log('body', body);
        xhttp.send(JSON.stringify(body));
    });

}

async function qrcodeCheck(staffQrCode) {
    console.log('qrcodeCheck', staffQrCode);
    try {
        let data = {
        };
        const response = await getAccessToken();
        console.log('response1', response, typeof (response));
        Token = response['access_token'];
        console.log('access_token', Token);
        const response2 = await qrcodeVerify(Token, staffQrCode);
        console.log('response2', response2,typeof(response2));
        return response2;
    }
    catch (ex) {
        console.log('qrcodeCheck ex', ex);
    }

}

async function networkTest() {
    await qrcodeCheck("VIRSICAL.3.PqKoN4cMDt7vtXYZEHoegw*1685072699401");
    await lockerCallback(Token);
}

//https://javascript.info/xmlhttprequest
function visitorExpiredCallback(body) {
    const url = `${WMSAPIIP}/vsk/vst-visitor/api/whiteList/lockerNoticeCallback`;

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.timeout = 5000;

        xhttp.onreadystatechange = function () {
            console.log('networktest14', this.readyState, this.status);
            if (this.readyState == 4) {  // && this.status == 200
                try {
                    console.log('responseText', this.responseText, typeof (this.responseText));
                    try {
                        const res = JSON.parse(this.responseText);
                        resolve(res);
                    } catch (err) {
                        resolve({ code: -1, msg: 'Network issue4' });
                    }
                } catch(error) {
                    resolve({code:1,msg:'Error! Please retry.'});
                }
            }
        };

        xhttp.open("POST", url);
        xhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        //xhttp.setRequestHeader("Authorization", "bearer " + token);
        xhttp.send(JSON.stringify(body));

    });

}

function rightRotate(value, amount) {
    return (value >>> amount) | (value << (32 - amount));
};

function sha256(ascii) {
    try {
        var mathPow = Math.pow;
        var maxWord = mathPow(2, 32);
        var lengthProperty = 'length'
        var i, j; // Used as a counter across the whole file
        var result = ''

        var words = [];
        var asciiBitLength = ascii[lengthProperty] * 8;

        //* caching results is optional - remove/add slash from front of this line to toggle
        // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
        // (we actually calculate the first 64, but extra values are just ignored)
        var hash = sha256.h = sha256.h || [];
        // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
        var k = sha256.k = sha256.k || [];
        var primeCounter = k[lengthProperty];
        /*/
        var hash = [], k = [];
        var primeCounter = 0;
        //*/

        var isComposite = {};
        for (var candidate = 2; primeCounter < 64; candidate++) {
            if (!isComposite[candidate]) {
                for (i = 0; i < 313; i += candidate) {
                    isComposite[i] = candidate;
                }
                hash[primeCounter] = (mathPow(candidate, .5) * maxWord) | 0;
                k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
            }
        }

        ascii += '\x80' // Append Ƈ' bit (plus zero padding)
        while (ascii[lengthProperty] % 64 - 56) ascii += '\x00' // More zero padding
        for (i = 0; i < ascii[lengthProperty]; i++) {
            j = ascii.charCodeAt(i);
            if (j >> 8) return; // ASCII check: only accept characters in range 0-255
            words[i >> 2] |= j << ((3 - i) % 4) * 8;
        }
        words[words[lengthProperty]] = ((asciiBitLength / maxWord) | 0);
        words[words[lengthProperty]] = (asciiBitLength)

        // process each chunk
        for (j = 0; j < words[lengthProperty];) {
            var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
            var oldHash = hash;
            // This is now the undefinedworking hash", often labelled as variables a...g
            // (we have to truncate as well, otherwise extra entries at the end accumulate
            hash = hash.slice(0, 8);

            for (i = 0; i < 64; i++) {
                var i2 = i + j;
                // Expand the message into 64 words
                // Used below if 
                var w15 = w[i - 15], w2 = w[i - 2];

                // Iterate
                var a = hash[0], e = hash[4];
                var temp1 = hash[7]
                    + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
                    + ((e & hash[5]) ^ ((~e) & hash[6])) // ch
                    + k[i]
                    // Expand the message schedule if needed
                    + (w[i] = (i < 16) ? w[i] : (
                        w[i - 16]
                        + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) // s0
                        + w[i - 7]
                        + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10)) // s1
                    ) | 0
                    );
                // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
                var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
                    + ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); // maj

                hash = [(temp1 + temp2) | 0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
                hash[4] = (hash[4] + temp1) | 0;
            }

            for (i = 0; i < 8; i++) {
                hash[i] = (hash[i] + oldHash[i]) | 0;
            }
        }

        for (i = 0; i < 8; i++) {
            for (j = 3; j + 1; j--) {
                var b = (hash[i] >> (j * 8)) & 255;
                result += ((b < 16) ? 0 : '') + b.toString(16);
            }
        }
    } catch (error) {
        result = '*******';
    }

    return result;
};

//NOTE: visitorCheck
function visitorCheck(token, visitorId) {
    let url = `${WMSAPIIP}/vsk/vst-visitor/api/whiteList/lockerScanCodeCallback?qrCodeContent=${visitorId}`;
    if (KioskId == 'OFFICE2') {
        url = `${WMSAPIIP}/vsk/vst-visitor/api/interface/lockerScanCodeCallback?qrCodeContent=${visitorId}`;
    }

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.timeout = 5000;

        xhttp.onreadystatechange = function () {
            console.log('networktest13', this.readyState, this.status);
            if (this.readyState == 4) {  // && this.status == 200
                try {
                    console.log('responseText', this.responseText, typeof (this.responseText));
                    try {
                        const res = JSON.parse(this.responseText);
                        resolve(res);
                    } catch (err) {
                        resolve({ code: -1, msg: 'Network issue5' });
                    }
                } catch (error) {
                    resolve({ code: 1, msg: 'Error! Please retry.' });
                }
            }
        };
        xhttp.open("POST", url);
        if (KioskId == 'OFFICE2') {
            url = `${WMSAPIIP}/vsk/vst-visitor/api/interface/lockerScanCodeCallback?qrCodeContent=${visitorId}`;
            console.log('==> visitorCheck url', url);
            console.log('==> visitorCheck access_token', token);
            const timestamp = Date.now() + 60 * 20 * 1000;
            const ClientSecret = '37942070-2a00-4b82-8415-7295983b0ae8';
            const api = `/api/interface/lockerScanCodeCallback{qrCodeContent=${visitorId}}`;
            let sign = sha256(token + ClientSecret + timestamp+api);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            xhttp.setRequestHeader("vsk-timestamp", timestamp);
            xhttp.setRequestHeader("vsk-auth", "bearer " + token);
            xhttp.setRequestHeader("vsk-signature", sign);
        }
        xhttp.send();
    });
}

//KioskId == 'OFFICE2'
function visitorCheckCSharp(token, visitorId) {
    let url = `/locker/api/v1/visitorCheck`;
    console.log('visitorCheckCSharp', token, visitorId);

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.timeout = 7000;

        xhttp.onreadystatechange = function () {
            console.log('networktest53', this.readyState, this.status);
            if (this.readyState == 4) {  // && this.status == 200
                try {
                    console.log('responseText', this.responseText, typeof (this.responseText));
                    try {
                        const res = JSON.parse(this.responseText);
                        resolve(res);
                    } catch (err) {
                        resolve({ code: -1, msg: 'Network issue6' });
                    }
                } catch (error) {
                    resolve({ code: 1, msg: 'Error! Please retry.' });
                }
            }
        };
        xhttp.open("POST", url);

        const timestamp = Date.now() + 60 * 1000 * 60;
        //uat
        //const ClientSecret = '37942070-2a00-4b82-8415-7295983b0ae8';
        //production
        const ClientSecret = '19c40b19-8f59-43b7-9def-90dcb8244306';
        const api = `/api/interface/lockerScanCodeCallback{qrCodeContent=${visitorId}}`;
        let sign = sha256(token + ClientSecret + timestamp + api);
        xhttp.setRequestHeader('Content-Type', 'application/json');
        xhttp.setRequestHeader("vsk-timestamp", timestamp);
        xhttp.setRequestHeader("vsk-auth", "bearer " + token);
        xhttp.setRequestHeader("vsk-signature", sign);

        const body = {
            "header": visitorId,
            "arg1": token,
            "arg2": timestamp,
            "arg3": sign,
            "arg4": sign,
        };
        xhttp.send(JSON.stringify(body));
    });
}

async function emailCheck() {
    let email = document.getElementById('emailInput').value;
    console.log('email', email,Token);
    Recipients = email;
    if (email == '') {
        document.getElementById('emailInputMsg').innerHTML = "Please enter email on virtual keyboard.";
    } else {
        const response = await lockerCallback(Token);
        console.log('response', response);
        if (response.code == 0) {
            console.log('SelectedBox', SelectedBox);
            let boxesStatuslist = BoxesStatus.split(',');
            boxesStatuslist[SelectedBox - 1] = Passcode;
            localStorage.setItem('boxStatus', boxesStatuslist.join(','));

            goHomePage();
        } else {
            document.getElementById('emailInputMsg').innerHTML = "Invalid email! Please try again.";
        }
    }

}

async function xxvisitorCheck(visitorId) {
    try {
        let data = {
        };
        const url = `${WMSAPIIP}/vsk/vst-visitor/api/whiteList/lockerScanCodeCallback?qrCodeContent=${visitorId}`;
        let response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
        });
        console.log('response', response.ok);
        const result = await response.json();
        console.log('result', result);
        return result;
    }
    catch (ex) {
        console.log('ex', ex);
        return {};
    }

}

//CourierModePage
async function checkIfDoorOpen() {
    let ledoff = false;
    if (checkIfDoorOpenCount == 0) {
        checkIfDoorOpenTime = performance.now();
    }
    checkIfDoorOpenCount++;

    let timeElapsed = (performance.now() - checkIfDoorOpenTime) / 1000;
    console.log('checkIfDoorOpen:', BoxNo, checkIfDoorOpenCount, timeElapsed);

    if (timeElapsed < MaxDoorCheckTime * 2) {

        if (timeElapsed >= 9) {
            let actDoorState = await readSingleDoorStatus(BoxNo);
            if (actDoorState == 'opened') {
                ledoff = true;
                console.log('door opened', BoxNo);
                await delay(300);
            }
            else {
                ledoff = false;
                let ledState = await readSingleDoorLED(BoxNo);
                if (ledState == 'off') {
                    //ledoff = true;
                    await delay(500);
                    ledState = await readSingleDoorLock(BoxNo);
                    if (ledState == 'off') {
                        ledoff = true;
                    }

                }
            }
        }
        else {
            await delay(300);

        }
        //console.log('led off:', BoxNo, ledoff);

        //if (await readSingleDoorStatus(BoxNo) == 'opened') {
        if (ledoff) {
            ledoff = false;
            console.log('checkIfDoorOpen: closed');
            checkIfDoorOpenCount = 0;
            courierStep = 10; //11
            doCourierModeRemoveBlink();
            doorChecking = false;
            await doCourier();
        } else {
            await checkIfDoorOpen();
        }
    }
    else {
        console.log('checkIfDoorOpen: timeout');
        checkIfDoorOpenCount = 0;
        courierStep = 10; //11
        doCourierModeRemoveBlink();
        doorChecking = false;
        await doCourier();
    }
}

async function checkIfDoorClose() {
    let ledoff = false;
    if (checkIfDoorCloseCount == 0) {
        checkIfDoorCloseTime = performance.now();
    }
    checkIfDoorCloseCount++;

    let timeElapsed = (performance.now() - checkIfDoorCloseTime) / 1000;
    console.log('checkIfDoorClose:', BoxNo, checkIfDoorCloseCount, timeElapsed);

    if (timeElapsed < MaxDoorCheckTime * 2) {

        if (timeElapsed >= 9) {
            let actDoorState = await readSingleDoorStatus(BoxNo);
            if (actDoorState == 'opened') {
                ledoff = true;
                console.log('door opened', BoxNo);
                await delay(300);
            }
            else {
                ledoff = false;
                let ledState = await readSingleDoorLED(BoxNo);
                if (ledState == 'off') {
                    //ledoff = true;
                    await delay(500);
                    ledState = await readSingleDoorLock(BoxNo);
                    if (ledState == 'off') {
                        ledoff = true;
                    }

                }
            }

        }
        else {
            await delay(300);

        }
        //console.log('led off', ledoff);

        //if (ledoff && await readSingleDoorStatus(BoxNo) == 'closed') {
        if (ledoff) {
            ledoff = false;
            console.log('checkIfDoorClose: closed');
            checkIfDoorCloseCount = 0;
        } else {
            console.log('checkIfDoorClose: opened');
            await checkIfDoorClose();
        }
    }
    else {
        console.log('checkIfDoorClose: timeout');
        checkIfDoorCloseCount = 0;
    }
}


async function handleExpired(statusList) {
    let tno = document.getElementById('trackingNo');
    console.log('handleExpiredtno', tno.value);
    let credList = CustomerCredentials.split(',');

    BoxNo = expiredIndex(statusList);;
    console.log('found', BoxNo);
    document.getElementById('courierModeBlink' + (BoxNo)).style.backgroundColor = 'green';
    await doOpenBox(BoxNo);
    docourierModeBlink(BoxNo);

    //@@hf:add true if want to update
    if (ViewBagUpdateMode || (ViewBagTestMode != true && ViewBagDebug != true)) {
        let response = await fetch(`/locker/api/v1/expired?kiosk_id=${KioskId}&boxNo=` + BoxNo + '&cred=' + credList[BoxNo - 1], {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        //console.log('response', response);
    }
    CourierExpiredState[BoxNo - 1] = true;

    doorChecking = true;
    checkIfDoorOpenCount = 0;
    await checkIfDoorOpen();
    doorChecking = false;
}

async function handleReserved(statusList) {
    let validTrackingNo = false;
    let tno = document.getElementById('trackingNo');
    console.log('handleReserved tno', tno.value);
    let credList = CustomerCredentials.split(',');
    //console.log('credList:', credList);
    //console.log('statusList:', statusList);
    if (tno.value != '') {
        BoxNo = 0;
        for (let i = 0; i < statusList.length; i++) {
            let trackingNo = credList[i].split(':')[0];
            console.log('CourierReservedState:', CourierReservedState[i]);
            console.log('status:', statusList[i]);
            console.log('cred:', credList[i], trackingNo, tno.value.toUpperCase());
            console.log('cred2:', trackingNo.length, tno.value.length);
            if (statusList[i] == 'reserved' && !CourierReservedState[i] && trackingNo == tno.value.toUpperCase()) {
                BoxNo = i + 1;
                console.log('found', BoxNo);
                document.getElementById('courierModeBlink' + (BoxNo)).style.backgroundColor = 'green';
                await doOpenBox(BoxNo);
                docourierModeBlink(BoxNo);
                //clear count for new delivery
                CustomerCollectCount[i] = 0;

                //@@hf:add true if want to update
                if (ViewBagUpdateMode || (ViewBagTestMode != true && ViewBagDebug != true)) {
                    //! update status
                    let response = await fetch(`/locker/api/v1/delivered?kiosk_id=${KioskId}&boxNo=` + BoxNo + '&cred=' + credList[i], {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    });
                    //console.log('response', response);
                }

                CourierReservedState[i] = true;
                document.getElementById('trackingNo').value = '';

                //if (reservedCount(statusList) > 0) {
                //    document.getElementById('courierMsg').innerHTML = '?????';
                //}
                //else {
                //    let msg = document.getElementById('courierMsg');
                //    msg.innerHTML = '??????,????';
                //    courierStep = 50;
                //}

                let selLang = SelectedLang == 'en' ? 0 : 1;
                document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["PleaseDeliverParcel"][selLang];
                courierStep = 30;
                validTrackingNo = true;

                doorChecking = true;
                checkIfDoorCloseCount = 0;
                await checkIfDoorClose();
                doorChecking = false;

                courierStep = 30;
                doCourierModeRemoveBlink();
                await doCourier();
                break;
            }
        }
    }

    if (!validTrackingNo) {
        let selLang = SelectedLang == 'en' ? 0 : 1;
        document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["IncorrectBarcodePleaseScanTheBarcodeAgain"][selLang];

        setTimeout(() => {
            let msg = document.getElementById('courierMsg');
            if (msg != null)
                msg.innerHTML = JSAllDictionaryItems["PleaseScanDeliverParcelBarcode"][selLang];
        }, 3000);

    }
}

// if expired order exist
//1. begin
//2. open box
//3. scan
//4. repeat 2,3 if not done
//5. complete

//if reserved order exist
//6. scan
//7. check if tracking_number exist
//8. open box
//9. check if box closed
//10. repeat 6-8 if not done
//11. all complete
async function doCourier() {
    let selLang = SelectedLang == 'en' ? 0 : 1;
    console.log('doCourier...', courierStep, doorChecking);
    if (doorChecking) {
        return
    }

    let statusList = BoxesStatus.split(',');
    CountDown = 60;

    if (courierStep == 10) {
        //courierStep = 11;
        checkIfDoorOpenCount = 0;
        if (document.getElementById('expiredIcon') != null) {
            document.getElementById('expiredIcon').style.visibility = 'visible';
        }

        if (expiredCount(statusList) == 0) {
            courierStep = 30;
            if (document.getElementById('courierMsg') != null) {
                document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["CollectParcelCompletedTapHereToContinue"][selLang];
            }
        }
        else {
            if (document.getElementById('courierMsg') != null) {
                document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["PleaseCollectParcel"][selLang];
            }
            await handleExpired(statusList);
        }
    }
    else if (courierStep == 11) {
        checkIfDoorOpenCount = 999;
        //document.getElementById('courierMsg').innerHTML = '???????????';
        if (expiredCount(statusList) > 0) {
            courierStep = 10;
        }
        else {
            courierStep = 30;
        }
    }
    //else if (courierStep == 20) {
    //    await handleExpired(statusList);
    //}
    else if (courierStep == 30) {
        checkIfDoorCloseCount = 999;
        reservedTotalCount(statusList);
        document.getElementById('courierDesc').innerHTML = JSAllDictionaryItems["RemainingDeliverItemsAndTotalDeliverItems"][selLang];
        document.getElementById('deliverIcon').style.visibility = 'visible';
        if (reservedCount(statusList) > 0) {
            let msg = document.getElementById('courierMsg');
            msg.innerHTML = JSAllDictionaryItems["PleaseScanDeliverParcelBarcode"][selLang];
            courierStep = 40;
        }
        else {
            let msg = document.getElementById('courierMsg');
            msg.innerHTML = JSAllDictionaryItems["DeliverParcelCompletedTapHereToExit"][selLang];
            courierStep = 50;
        }
    }
    else if (courierStep == 40) {
        checkIfDoorCloseCount = 0;

        await ImportNewOrders();
        await init_BoxesStatus();
        await handleReserved(statusList);
    }
    else if (courierStep == 41) {
        courierStep = 50;
    }
    else if (courierStep == 50) {
        console.log('goHomePage');
        checkIfDoorCloseCount = 999;
        goHomePage();
    }
}

//ReOpenPage
async function doReopen() {
    console.log('doReopen...', ReOpenMode);

    ReOpenMode = true;
    //    let img = `/locker/img/${SelectedLang}/unlocked.png?rnd=34901163`;
    //    document.getElementById('imgUnlocked').src = img;
    //    document.getElementById('imgUnlocked').style.visibility = 'visible';

    //    for (let i = 0; i < CollectBoxList.length; i++)
    //    {
    //        console.log('doReopen', CollectBoxList[i]);
    //        await doOpenBox(CollectBoxList[i]);
    //    }

    //change to go to collect page
    doCollect();
}

//CollectPage
async function collectInit() {
    let customerCollectCountExceed = false;
    //let statusList = BoxesStatus.split(',');
    let credlist = CustomerCredentials.split(',');

    await collectedTotalCount();

    collectCheckIfDoorCloseCount = 0;
    await collectCheckIfDoorClose();

    //@@hf:add true if want to update
    if (ViewBagUpdateMode || (ViewBagTestMode != true && ViewBagDebug != true)) {
        for (let i = 0; i < CollectBoxList.length; i++) {
            //! update status
            let boxno = CollectBoxList[i];
            let response = await fetch(`/locker/api/v1/collected?kiosk_id=${KioskId}&boxNo=` + boxno + '&cred=' + credlist[boxno - 1], {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            //console.log('response', response);
            //    if (CustomerCollectCount[i] >= 3)
            //    {
            //        customerCollectCountExceed = true;
            //    }
        }
    }

    //doCollectRemoveBlink();

    if (CurrentPage != 'HomePage') {
        //if (ReOpenMode || customerCollectCountExceed)
        //@hf
        if (true || ReOpenMode) {
            goThankYouPage();
        }
        else {
            goReopenPage();
        }
    }
}

async function xxxcollectedTotalCount() {
    let boxesStatuslist = BoxesStatus.split(',');
    let credlist = CustomerCredentials.split(',');

    let count = 0;
    collectBoxList = [];
    CollectBoxList = [];
    //for (let i = 0; i < statusList.length; i++) {
    //    if (statusList[i] == 'occupied') {
    //        let cb = document.getElementById('collectBlink' + (i + 1));
    //        cb.classList.add('blinking');
    //        collectBoxList.push(i + 1);

    //        await doOpenBox(i + 1);

    //        count++;
    //    }
    //}
    //document.getElementById('courierTotalCount').innerText = '/' + count;

    for (let i = 0; i < credlist.length; i++) {
        let pos1 = credlist[i].indexOf(':');
        let pos2 = credlist[i].substr(pos1 + 1).indexOf(':');
        let cred = credlist[i].substr(pos1 + pos2 + 1).replace(':', '');
        console.log('cred:', cred, keylist, boxesStatuslist[i]);
        // && boxesStatuslist[i] == 'occupied'
        if (keylist.length >= 8 && keylist == cred) {
            console.log('matched2', keylist, i + 1);
            //document.getElementById('collectBlink' + (i + 1)).style.backgroundColor = 'green';
            let pngFile = "url('/locker/img/box/" + (i + 1) + ".png')";
            console.log('pngFile', pngFile)
            document.getElementById('collectBlink' + (i + 1)).style.backgroundImage = pngFile;

            //let cb = document.getElementById('collectBlink' + (i + 1));
            //cb.classList.add('blinking');
            collectBoxList.push(i + 1);
            CollectBoxList.push(i + 1);

            await doOpenBox(i + 1);
            //await delay(300);

            count++;
            //break;
        }
    }

    CountDown = 60 * count;

    return count;
}

async function deliveredTotalCount() {
    const order1 = [1,2,3,4,5,6,7,8,9,10];
    const order2 = [6,10,5,9,4,8,3,7,2,1];
    let boxesStatuslist = BoxesStatus.split(',');

    let count = 0;
    collectBoxList = [];
    CollectBoxList = [];

    for (let i = 0; i < boxesStatuslist.length; i++) {
        if (boxesStatuslist[i] == keylist) {
            return 'exist';
        }
    }

    for (let idx = 0; idx < boxesStatuslist.length; idx++) {
        let i = order1[idx]-1;
        if (HandicappedMode) {
            i = order2[idx]-1;
        }
        console.log('cred2:', keylist, boxesStatuslist[i],i);
        if (boxesStatuslist[i] == '') {
            console.log('available', keylist, i + 1);

            //let cb = document.getElementById('collectBlink' + (i + 1));
            //cb.classList.add('blinking');
            //collectBoxList.push(i + 1);
            //CollectBoxList.push(i + 1);

            //@hf: delay 3 seconds before open box
            //await doOpenBox(i + 1);
            SelectedBox = i + 1;
            await dotnetJSConsole('JsConsole:' + KioskId, "deliveredTotalCount", keylist, BoxesStatus, SelectedBox, null)

            //await delay(3000);
            console.log('OperationMode', OperationMode);
            if (OperationMode == 'staffDeliver') {
                const rnd = Math.floor(Math.random() * 100000000);
                Passcode = `00000000${rnd}`.slice(-8);
                boxesStatuslist[i] = Passcode;
                //save after email is valid
                //localStorage.setItem('boxStatus', boxesStatuslist.join(','));
            } else {
                boxesStatuslist[i] = keylist;
                localStorage.setItem('boxStatus', boxesStatuslist.join(','));

                //update vistor's mobile no.
                const boxMobile = localStorage.getItem('boxMobile');
                console.log('boxMobile:', boxMobile);
                let boxMobileList = boxMobile.split(',');
                boxMobileList[i] = VisitorMobile;
                localStorage.setItem('boxMobile', boxMobileList.join(','));

            }
            //@hfa
            BoxesStatus = boxesStatuslist.join(',');

            count++;
            return i+1;
        }
    }

    return 'full';
}

async function collectedTotalCount() {
    let boxesStatuslist = BoxesStatus.split(',');

    let count = 0;
    collectBoxList = [];
    CollectBoxList = [];

    for (let i = 0; i < boxesStatuslist.length; i++) {
        console.log('cred:', keylist, boxesStatuslist[i]);
        if (boxesStatuslist[i] == keylist) {
            //@hf: delay 3 seconds before open box
            //await doOpenBox(i + 1);
            SelectedBox = i + 1;
            await dotnetJSConsole('JsConsole:' + KioskId, "collectedTotalCount", keylist, BoxesStatus, SelectedBox, null)

            //await delay(3000);
            boxesStatuslist[i] = '';
            localStorage.setItem('boxStatus', boxesStatuslist.join(','));
            //@hfa
            BoxesStatus = boxesStatuslist.join(',');
            return i + 1;
        }
    }

    return 0;
}

async function collectCheckIfDoorClose() {
    let ledoff = false;
    let complete = false;
    let totalNo = collectBoxList.length;
    let closeNo = 0;
    if (collectCheckIfDoorCloseCount == 0) {
        collectCheckIfDoorCloseTime = performance.now();
    }
    collectCheckIfDoorCloseCount++;

    let timeElapsed = (performance.now() - collectCheckIfDoorCloseTime) / 1000;
    console.log('collectCheckIfDoorClose', totalNo, closeNo, collectCheckIfDoorCloseCount, timeElapsed);

    if (timeElapsed < MaxDoorCheckTime * totalNo) {

        for (let i = 0; i < totalNo; i++) {
            let boxNo = collectBoxList[i];
            if (boxNo == 0) {
                closeNo++;
                continue;
            }
            if (timeElapsed >= 9) {
                let actDoorState = await readSingleDoorStatus(boxNo);
                if (actDoorState == 'opened') {
                    ledoff = true;
                    console.log('collectCheckIfDoorClose: door opened', boxNo);
                    await delay(300);
                }
                else {
                    ledoff = false;
                    let ledState = await readSingleDoorLED(boxNo);
                    if (ledState == 'off') {
                        //ledoff = true;
                        await delay(500);
                        ledState = await readSingleDoorLock(boxNo);
                        if (ledState == 'off') {
                            ledoff = true;
                        }

                    }
                }
            }
            else {
                await delay(300);

            }

            //console.log('led off:', boxNo, ledoff);
            if (ledoff) {
                ledoff = false;
                //if (ledoff && await readSingleDoorStatus(boxNo) == 'closed') {
                console.log('collectCheckIfDoorClose: closed', boxNo);
                closeNo++;
                collectBoxList[i] = 0;
                doCollectRemoveBlink(boxNo);
            } else {
                //console.log('collectCheckIfDoorClose: opened');
            }
            //await delay(500);
        }

        //console.log('closeNo', closeNo);
        if (closeNo < totalNo) {
            await collectCheckIfDoorClose();
        }
        else {
            console.log('collectCheckIfDoorClose: complete');
            collectCheckIfDoorCloseCount = 0;
        }
    }
    else {
        console.log('collectCheckIfDoorClose: timeout');
        collectCheckIfDoorCloseCount = 0;
    }
}


async function proceedOpenbox() {
    let result = 'ok';
    console.log('proceedopenbox', OperationMode);

    if (OperationMode == 'guestDeliver' || OperationMode == 'staffDeliver') {
        const res = await deliveredTotalCount();
        if (res == 'full') {
            document.getElementById('LoginMessage').innerHTML = 'All boxes are used up';
            result = res;
        }
        else if (res == 'exist') {
            document.getElementById('LoginMessage').innerHTML = 'You already delivered the item';
            result = res;
        } else {
            CountDown = 10;
            CurrentPage = 'CollectPage';
            var template = document.getElementById('homeTemplate').innerHTML;
            var rendered = Mustache.render(template, { collectPage: 'visible' });
            document.getElementById('target').innerHTML = rendered;
            document.getElementById('collectBlink' + res).style.backgroundColor = 'red';
            console.log('proceedopenbox2', OperationMode);
            if (OperationMode == 'staffDeliver') {
                document.getElementById('btnEmailInput').style.visibility = 'visible';
            } else {
                document.getElementById('btnEmailInput').style.visibility = 'hidden';
            }

            //@hf:open box after 3 seconds
            const selBox = SelectedBox;
            await delay(2500);
            console.log('open box after 3 seconds', selBox);
            await doOpenBox(selBox);
        }
    } else {
        const res = await collectedTotalCount();
        if (res == 0) {
            document.getElementById('LoginMessage').innerHTML = 'Invalid ID! Please try again.';
            result = res;
        } else {
            CountDown = 10;
            CurrentPage = 'CollectPage';
            var template = document.getElementById('homeTemplate').innerHTML;
            var rendered = Mustache.render(template, { collectPage: 'visible' });
            document.getElementById('target').innerHTML = rendered;
            document.getElementById('collectBlink' + res).style.backgroundColor = 'green';
            document.getElementById('btnEmailInput').style.visibility = 'hidden';

            //@hf:open box after 3 seconds
            const selBox = SelectedBox;
            await delay(2500);
            console.log('open box after 3 seconds.', selBox);
            await doOpenBox(selBox);
        }
    }
    await dotnetJSConsole('JsConsole:' + KioskId, "proceedOpenbox", keylist, BoxesStatus, OperationMode, SelectedBox)

    keylist = '';
    return result;
}

async function doCollect2(courierPw) {
    console.log('doCollect2...', OperationMode, KioskId, keylist);
    await dotnetJSConsole('JsConsole:' + KioskId, "doCollect2", keylist, BoxesStatus, null, null)

    CountDown = 60;
    BoxNo = 0;
    const boxStatus = localStorage.getItem('boxStatus');
    console.log('BoxesStatus:', boxStatus);
    if (boxStatus == null) {
        const status = ',,,,,,,,,,'
        localStorage.setItem('boxStatus', status);
    }
    BoxesStatus = boxStatus;

    //vistor's mobile no.
    const boxMobile = localStorage.getItem('boxMobile');
    console.log('boxMobile:', boxMobile);
    if (boxMobile == null) {
        const status = ',,,,,,,,,,'
        localStorage.setItem('boxMobile', status);
    }


    //    let boxesStatuslist = BoxesStatus?.split(',');
    //    let credlist = CustomerCredentials?.split(',');
    //console.log('credlist:', credlist);
    //console.log('boxesStatuslist:', boxesStatuslist);
    //console.log('CourierReservedState:', CourierReservedState);


    console.log('BoxNo', BoxNo);

    if (BoxNo > 0) {
        //CountDown = 120;
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { collectPage: 'visible' });
        document.getElementById('target').innerHTML = rendered;

        if (TotalKiosks == 3) {
            let img = `/locker/img/${SelectedLang}/Collect-2unit.png?rnd=34901162`;
            document.getElementById('collect').src = img;
        }
        else {
            let img = `/locker/img/${SelectedLang}/Collect.png?rnd=34901162`;
            document.getElementById('collect').src = img;
        }

        //setTimeout(function() { collectInit(); }, 100);
        await collectInit();

    }
    else if (keylist == '1111111111111122222') {
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { collectPage: 'visible' });
        document.getElementById('target').innerHTML = rendered;
    }
    else if (keylist == 'collectPage') {
        CountDown = 60;
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { collectPage: 'visible' });
        document.getElementById('target').innerHTML = rendered;
        document.getElementById('collectBlink' + BoxNo).style.backgroundColor = 'green';
    }
//enter 00 to reload
    else if (keylist == '0' || keylist == '00') {
        window.location.reload(true);
    }
    else if (keylist == '90887274') {
        window.location.href = '/en/first-page';
    }
//passcode to admin page
    else if (keylist == 'hfwg9088') {
        CountDown = 60;
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { controlPage: 'visible' });
        document.getElementById('target').innerHTML = rendered;

        dispBoxStatus();
    }
//passcode to admin page with Clear button
    else if (keylist == 'hfwg9087') {
        CountDown = 60;
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { controlPage: 'visible' });
        document.getElementById('target').innerHTML = rendered;

        document.getElementById('clearAllBoxStatus').style = 'visibility:visible';
        dispBoxStatus();
    }
    else if (keylist == '90887291') {
        await proceedOpenbox();
    }
    else if (keylist == '90887294' || keylist == '90887295' || keylist == '90887296') {
        await proceedOpenbox();
    }
//    else if (keylist == '97' || keylist == '98' || keylist == '99' || keylist == '90') {
//        await proceedOpenbox();
//    }
//passcode to admin page
    else if (keylist == '852290129262') {
        CountDown = 90;
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { controlPage: 'visible' });
        document.getElementById('target').innerHTML = rendered;
        dispBoxStatus();
    }
    else if (keylist == courierPw) {
        var template = document.getElementById('homeTemplate').innerHTML;
        var rendered = Mustache.render(template, { courierModePage: 'visible' });
        document.getElementById('target').innerHTML = rendered;

        for (let i = 0; i < CourierReservedState.length; i++) {
            CourierReservedState[i] = false;
            CourierExpiredState[i] = false;
        }
        //setTimeout(function () { courierInit(); }, 200);
        await ImportNewOrders();
        await init_BoxesStatus();
        await courierInit();

    }
    else {
        //        let img = `/locker/img/${SelectedLang}/invalidPasscode.png?rnd=34901162`;
        //        document.getElementById("invalidPasscode").src = img;
        // Get the helpModal
        //        collectModal = document.getElementById("collectModal");
        //        collectModal.style.display = "block";
        //        collectModalTimer = setTimeout("collectModal.style.display = 'none'", 10000);

        if (keylist == '') {
            document.getElementById('LoginMessage').innerHTML = "Please enter ID";
            keyPad(10);
        }
        else {
            let result;
            if (OperationMode == 'staffDeliver') {
                result = await qrcodeCheck(keylist);
                console.log('result1', result, typeof (result));
                if (result.code == 0) {
                    const res = await proceedOpenbox();
                    if (res == 'ok') {
                        goReopenPage(); //email
                    }
                } else {
                    document.getElementById('LoginMessage').innerHTML = result.msg;
                    keylist = '';
                    keyPad(10);
                }
            } else if (OperationMode == 'staffCollect') {
                console.log('staffCollect');
                await proceedOpenbox();
            } else {
                //@hfa
                Token = '';
                await dotnetJSConsole('JsConsole:' + KioskId, "visitorCheckCSharp KioskId=", KioskId, null, null, null)
                if (KioskId == 'OFFICE2') {
                    const response = await getAccessToken();
                    console.log('response1', response, typeof (response));
                    Token = response['access_token'];
                    await dotnetJSConsole('JsConsole:' + KioskId, "visitorCheckCSharp Token", Token, keylist, null, null)
                    result = await visitorCheckCSharp(Token, keylist);
                } else {
                    result = await visitorCheck(Token, keylist);
                }
                console.log('result2', result, keylist);
                await dotnetJSConsole('JsConsole:' + KioskId, "result2", JSON.stringify(result), keylist, null, null)
                if (result.code == 0) {
                    VisitorMobile = result.data; //mobile no.
                    await dotnetJSConsole('JsConsole:' + KioskId, "before proceedOpenbox", Token, keylist, null, null)
                    await proceedOpenbox();
                } else {
                    document.getElementById('LoginMessage').innerHTML = result.msg;
                    await dotnetJSConsole('JsConsole:' + KioskId, "visitorCheck result.msg", keylist, BoxesStatus, result.msg, null)

                    keylist = '';
                    keyPad(10);
                }
            }

        }

    }
}


async function goReopenPage() {
    console.log('goReopenPage...', keylist);
    //await delay(300);
    CountDown = 60;
    CurrentPage = 'ReopenPage';
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { reopenPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

//    let img = `/locker/img/${SelectedLang}/reopen.png?rnd=34907681`;
//    document.getElementById('reopen').src = img;
    init_keyboard();

}

async function GetBoxesStatusAndCredentials() {
    let url = `/locker/api/v1/getBoxesStatusAndCredentials?kiosk_id=${KioskId}`;
    let response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    let res = await response.text();
    return res;
}

function deliverTest() {
    CountDown = 60;
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { reopenPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

    init_keyboard();
}

function collectTest() {
    CountDown = 60;
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { collectPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

}

async function doLogin(mode) {
    console.log('doLogin...', mode, window.location.href, KioskId,keylist);
    await dotnetJSConsole('JsConsole:' + KioskId, "doLogin", keylist, BoxesStatus, null, null)
    OperationMode = mode;

    CountDown = 60;
    CurrentPage = 'LoginPage';
    courierStep = 10;
    doorAlertCancel = true;
    doorChecking = false;
    ReservedTotal = 0;
    ExpiredTotal = 0;
    doorAlertIndex = 0;
    focusInputActive = false;
    keylist = '';

    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { loginPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;
    //document.getElementById('Countdown').style = 'visibility:visible';

    SelectedLang = 'en';

    if (mode == 'guestDeliver') {
        document.getElementById("EnterSMSPickupPin").innerHTML = JSAllDictionaryItems["EnterSMSPickupPin"][0] + " " + JSAllDictionaryItems["EnterSMSPickupPin"][1];
        document.getElementById("YouMayScanTheQRCode").innerHTML = JSAllDictionaryItems["YouMayScanTheQRCode"][0] + "<br>" + JSAllDictionaryItems["YouMayScanTheQRCode"][1];
        document.getElementById("Collect").innerHTML = JSAllDictionaryItems["Deliver"][0] + "<br>" + JSAllDictionaryItems["Deliver"][1];
        document.getElementById("Handicapped").innerHTML = JSAllDictionaryItems["Handicapped"][0] + "<br>" + JSAllDictionaryItems["Handicapped"][1];
        //document.getElementById("btnHandicapped").style.visibility = "visible";
    }
    else if (mode == 'guestCollect') {
        document.getElementById("EnterSMSPickupPin").innerHTML = JSAllDictionaryItems["EnterSMSPickupPin"][0] + " " + JSAllDictionaryItems["EnterSMSPickupPin"][1];
        document.getElementById("YouMayScanTheQRCode").innerHTML = JSAllDictionaryItems["YouMayScanTheQRCode"][0] + "<br>" + JSAllDictionaryItems["YouMayScanTheQRCode"][1];
        document.getElementById("Collect").innerHTML = JSAllDictionaryItems["Collect"][0] + "<br>" + JSAllDictionaryItems["Collect"][1];
        document.getElementById("btnHandicapped").style.visibility = "hidden";
    } else if (mode == 'staffDeliver') {
        document.getElementById("EnterSMSPickupPin").innerHTML = JSAllDictionaryItems["EnterSMSPickupPin"][0] + " " + JSAllDictionaryItems["EnterSMSPickupPin"][1];
        document.getElementById("YouMayScanTheQRCode").innerHTML = JSAllDictionaryItems["YouMayScanTheQRCode"][0] + "<br>" + JSAllDictionaryItems["YouMayScanTheQRCode"][1];
        document.getElementById("Collect").innerHTML = JSAllDictionaryItems["StaffDeliver"][0] + "<br>" + JSAllDictionaryItems["StaffDeliver"][1];
        document.getElementById("Handicapped").innerHTML = JSAllDictionaryItems["Handicapped"][0] + "<br>" + JSAllDictionaryItems["Handicapped"][1]; 
        //document.getElementById("btnHandicapped").style.visibility = "visible";
    } else if (mode == 'staffCollect') {
        document.getElementById("EnterSMSPickupPin").innerHTML = JSAllDictionaryItems["EnterSMSPickupPin"][0] + " " + JSAllDictionaryItems["EnterSMSPickupPin"][1];
        document.getElementById("YouMayScanTheQRCode").innerHTML = JSAllDictionaryItems["YouMayScanTheQRCode"][0] + "<br>" + JSAllDictionaryItems["YouMayScanTheQRCode"][1];
        document.getElementById("Collect").innerHTML = JSAllDictionaryItems["StaffCollect"][0] + "<br>" + JSAllDictionaryItems["StaffCollect"][1];
        document.getElementById("btnHandicapped").style.visibility = "hidden";
    }

    //setTimeout("networkFailOver()", 5000);
    let name = window.localStorage.getItem('kioskName');
    try {
        //var req = new XMLHttpRequest();
        //req.open('GET', `/en?kiosk_id=${name}`, true);

        //req.onreadystatechange = function ()
        //{
        //    if (this.readyState == 4 && this.status == 200)
        //    {
        //        console.log('server is up');
        //        if (lang == 'en')
        //            window.location.href = `/en?kiosk_id=${name}`;
        //        else
        //            window.location.href = `/tc?kiosk_id=${name}`;
        //    }
        //};
        //req.send();

        //if (lang == 'en')
        //    window.location.href = `/en?kiosk_id=${name}`;
        //else
        //    window.location.href = `/tc?kiosk_id=${name}`;

        //await init_BoxesStatus();
        await init_LoginPage();

        setAndRunQrcode();

    }
    catch (ex) {
        console.log('ex', ex);
    }
    //htmx.ajax('GET', `/locker/api/v1/saveKioskName?kiosk_id=${name}`, { target: '#homeButton', swap: 'innerHTML' });
    //document.getElementById('HomePage').style = 'visibility:hidden';
    console.log('doLogin done')
}

function setAndRunQrcode() {
    console.log('setAndRunQrcode');
    QrcodeRunMode = true;
    //setTimeout(doQrcode, 1000);
    if (doQrcodeTimerId != null) clearTimeout(doQrcodeTimerId);
    doQrcodeTimerId = setTimeout(doQrcode, 800);
}

async function hifitest() {
    console.log('from hifitest111');
    await delay(3000);
    console.log('hifitest123 end');
}

async function networkFailOver() {
    console.log('networkFailOver');
    for (let i = 0; i < 10; i++) {
        await delay(3000);
        console.log('networkFailOver', i);
    }
}

function reloadTest() {
    //window.location.href = '/tc?kiosk_id=eric_kiosk'
    window.location.href = '/en/sms-setup'
}

//courierModePage

//$(document).ready(function ()
//{
//    console.log('CourierModePage init');

//});

async function clickPress(event) {
    if (event.keyCode == 13) {
        console.log('Input evt got')
        await doCourier();

        document.getElementById('trackingNo').value = '';

    }
}

function focusInput() {
    //@hf
    console.log('focusInput')
    let tno = document.getElementById('trackingNo');
    if (tno != null)
        tno.focus();
    if (focusInputActive)
        setTimeout(focusInput, 1000);
}

function courierInit() {
    try {
        console.log('courierInit:', BoxesStatus);
        let selLang = SelectedLang == 'en' ? 0 : 1;
        let statusList = BoxesStatus.split(',');
        ReservedTotal = reservedTotalCount(statusList);
        ExpiredTotal = expiredTotalCount(statusList);
        expiredCount(statusList);
        focusInputActive = true;
        focusInput();

        document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["Start"][selLang];
        document.getElementById('courierDesc').innerHTML = JSAllDictionaryItems["RemainingCollectItemsAndTotalCollectItems"][selLang];

        if (ReservedTotal + ExpiredTotal == 0) {
            document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["NoParcelNeededToCollectOrDeliver"][selLang];
            document.getElementById('courierDesc').innerHTML = '';
            courierStep = 50;
        }
        else if (ExpiredTotal == 0) {
            document.getElementById('courierMsg').innerHTML = JSAllDictionaryItems["NoParcelNeededToCollect"][selLang];
            courierStep = 30;
        }
        else {
            courierStep = 10;
        }
    }
    catch (error) {
        console.log('courierInit ex:', error);
    }
}

function courierModeBoxNum(num) {
    console.log('courierModeBoxNum', num)
}

function docourierModeBlink(boxNo) {
    console.log('docourierModeBlink...', boxNo);
}

function doCourierModeRemoveBlink() {
    //let cb = document.getElementById('courierModeBlink' + BoxNo);
    //console.log('doCourierModeRemoveBlink', BoxNo, cb);
    //if (cb != null) {
    //    cb.classList.remove('blinking');
    //}
}

function expiredTotalCount(statusList) {
    let count = 0;
    for (let i = 0; i < statusList.length; i++) {
        if (statusList[i] == 'expired') {
            if (!CourierExpiredState[i]) {
                document.getElementById('courierModeBlink' + (i + 1)).style.backgroundColor = '#004000';
            } else {
                document.getElementById('courierModeBlink' + (i + 1)).style.backgroundColor = 'grey';
            }

            count++;
        }
    }
    document.getElementById('courierTotalCount').innerText = '/' + count;
    return count;
}

function expiredCount(statusList) {
    let count = 0;
    for (let i = 0; i < statusList.length; i++) {
        if (statusList[i] == 'expired') {
            if (!CourierExpiredState[i]) {
                //document.getElementById('courierModeBlink' + (i + 1)).style.backgroundColor = 'darkgreen';
                count++;
            } else {
                document.getElementById('courierModeBlink' + (i + 1)).style.backgroundColor = 'grey';
            }

        }

    }
    document.getElementById('courierCount').innerText = '' + (ExpiredTotal - count);
    return count;
}

function expiredIndex(statusList) {
    for (let i = 0; i < statusList.length; i++) {
        if (statusList[i] == 'expired' && !CourierExpiredState[i]) {
            console.log('expired index ', i);
            return i + 1;
        }
    }
    return 0;
}

function reservedTotalCount(statusList) {
    let count = 0;
    for (let i = 0; i < statusList.length; i++) {
        if (statusList[i] == 'reserved') {
            if (!CourierReservedState[i]) {
                //document.getElementById('courierModeBlink' + (i + 1)).style.backgroundColor = '#134040';
            } else {
                let cmBlink = document.getElementById('courierModeBlink' + (i + 1));
                if (cmBlink != null)
                    document.getElementById('courierModeBlink' + (i + 1)).style.backgroundColor = 'grey';
            }

            count++;
        }
    }

    let ctCount = document.getElementById('courierTotalCount');
    if (ctCount != null)
        document.getElementById('courierTotalCount').innerText = '/' + count;
    return count;
}

function reservedCount(statusList) {
    let count = 0;
    for (let i = 0; i < statusList.length; i++) {
        if (statusList[i] == 'reserved' && !CourierReservedState[i]) {
            count++;
        }
    }

    let cCount = document.getElementById('courierCount');
    if (cCount != null)
        document.getElementById('courierCount').innerText = '' + (ReservedTotal - count);
    return count;
}


async function init_BoxesStatus() {
    //console.log('init_BoxesStatus..');

    let data = await GetBoxesStatusAndCredentials();
    let _data = data.split('|');
    if (_data.length >= 2) {
        BoxesStatus = _data[0];
        CustomerCredentials = _data[1];
        console.log('BoxesStatus', BoxesStatus);
        console.log('CustomerCredentials', CustomerCredentials);
    }
}

async function goThankYouPage() {
    console.log('goThankYouPage...');
    CurrentPage = 'ThankYouPage';
    CountDown = 10;

    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { thankYouPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

    let img = `/locker/img/Background.png?rnd=34901162`;
    document.getElementById('thankYou').src = img;

    await doOpenBox(SelectedBox);
}

const doExpireTimer = async () => {
    const ExpireTime = 22; //hour 0 - 23,20
    const now = new Date();
    const isoString = now.toISOString();
    const today = isoString.substr(0, 10);
    const hour = now.getHours();
    console.log("doExpireTimer", isoString, `${hour}---${ExpireTime}`);

    try {
        const pre_today = localStorage.getItem('boxExpired');
        console.log("pre_today", pre_today);
        //await dotnetJSConsole('JsConsole:' + KioskId, "doExpireTimer", isoString, `${today}---${pre_today}`, `${hour}---${ExpireTime}`, null)

        if (hour >= ExpireTime && (pre_today == null || today != pre_today)) {
            let result = [];
            let rec = {};
            const boxStatus = localStorage.getItem('boxStatus').split(',');
            const boxMobile = localStorage.getItem('boxMobile').split(',');
            console.log("==> boxExpired handling", boxStatus, '|', boxMobile);
            localStorage.setItem('boxExpired', today);
            await dotnetJSConsole('JsConsole:' + KioskId, "doExpireTimer reached", localStorage.getItem('boxStatus'), localStorage.getItem('boxMobile'), null, null)

            for (let i = 0; i < 10; i++) {
                if (boxStatus[i] != '' && boxMobile[i] != '') {
                    console.log("box occupied", i, boxMobile[i]);
                    //rec = { "visitorNumber": boxMobile[i], "lockerCode": (i+1).toString().padStart(2, '0') };
                    rec = { "visitorNumber": boxMobile[i], "lockerCode": (i+1).toString() };
                    result.push(rec);
                    await dotnetJSConsole('JsConsole:' + KioskId, "visitorNumber", boxMobile[i], (i + 1).toString(), null, null)
                }
            }
            if (result.length > 0) {
                console.log('result', result);
                console.log('result', JSON.stringify(result));
                await dotnetJSConsole('JsConsole:' + KioskId, "visitorExpiredCallback start", JSON.stringify(result), null, null, null)
                const res = await visitorExpiredCallback(result);

                await dotnetJSConsole('JsConsole:' + KioskId, "visitorExpiredCallback end", 'end2', null, null, null)
            }

        }
    }
    catch (ex) {
        console.log('doExpireTimer ex:', ex);
        await dotnetJSConsole('JsConsole:' + KioskId, "doExpireTimer ex", ex.message, null, null, null)
        localStorage.setItem('boxExpired', today);
    }

    if (expiredTimerId != null) clearTimeout(expiredTimerId);
    expiredTimerId = setTimeout(() => {
        doExpireTimer();
    }, 240000);
}

async function goHomePage() {
    BoxesStatus=localStorage.getItem('boxStatus');
    const boxMobile = localStorage.getItem('boxMobile');
    console.log('goHomePage...', HandicappedMode, OperationMode, keylist, BoxesStatus, boxMobile);
    //console.log('csLockControlResponse:', csLockControlResponse);
    await dotnetJSConsole('JsConsole:' + KioskId, "goHomePage", keylist, BoxesStatus, boxMobile, null)

    CurrentPage = 'HomePage';

    //@@hf
    //await monitorBoxStatus();
    checkIfDoorOpenCount = 9999;
    checkIfDoorCloseCount = 9999;
    collectCheckIfDoorCloseCount = 9999;
    courierStep = 9999;
    await delay(1);
    checkIfDoorOpenCount = 9999;
    checkIfDoorCloseCount = 9999;
    collectCheckIfDoorCloseCount = 9999;
    courierStep = 9999;
    ReOpenMode = false;
    QrcodeRunMode = false;
    HandicappedMode = false;
    focusInputActive = false;

    //window.location.reload()
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { homePage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

    document.getElementById('HomePage').style = 'visibility:visbile';
    //document.getElementById('Countdown').style = 'visibility:hidden';
    CountDown = 0;

    const boxStatus = BoxesStatus.split(',');
    console.log('BoxStatus', BoxesStatus);
    let count = 0;
    for (let i = 0; i < 10; i++) {
        if (boxStatus[i] == '') count++;
    }
    console.log('remainBoxCount', count);
    document.getElementById('remainBoxCount').innerHTML=`${count}`;

    //read temperature
    //{
    //    let msg1 = await readSingleControlTempSensor(1);
    //    let msg2 = await readSingleControlTempSensor(2);
    //    console.log('temperature11:', msg1);
    //    console.log('temperature12:', msg2);
    //}
    //{
    //    let msg1 = await readSingleDefrostTempSensor(1);
    //    let msg2 = await readSingleDefrostTempSensor(2);
    //    console.log('temperature21:', msg1);
    //    console.log('temperature22:', msg2);
    //}
    //{
    //    let msg1 = await readSingleCompressorTempSensor(1);
    //    let msg2 = await readSingleCompressorTempSensor(2);
    //    console.log('temperature31:', msg1);
    //    console.log('temperature32:', msg2);
    //}
    //{
    //    let msg1 = await readSingleDisplayTempSensor(1);
    //    let msg2 = await readSingleDisplayTempSensor(2);
    //    console.log('temperature41:', msg1);
    //    console.log('temperature42:', msg2);
    //}
    //{
    //    let msg1 = await readSingleStatusTempSensor(1);
    //    let msg2 = await readSingleStatusTempSensor(2);
    //    console.log('temperature61:', msg1);
    //    console.log('temperature62:', msg2);
    //}
    //{
    //    let msg1 = await readSingleAlarmTempSensor(1);
    //    let msg2 = await readSingleAlarmTempSensor(2);
    //    console.log('temperature81:', msg1);
    //    console.log('temperature82:', msg2);
    //}

    //    if (document.getElementById('lblRefriTemp') != null)
    //    {
    //document.getElementById('lblRefriTemp').innerHTML = `${msg1}, ${msg2}, ${msg3}`;
    //        document.getElementById('lblRefriTemp').innerHTML = `${msg1}, ${msg2}`;
    //    }

}

//LoginPage
var Credentials = '';
var BoxNo = 0;

async function init_LoginPage() {
    console.log('LoginPage init..');

    keylist = '';
    focusInputActive = true;
    pcfocusInput();

    document.getElementById('Countdown').style = 'visibility:visible';
    CountDown = 60;

}

async function redefine_console() {
    (function () {
        var _log = console.log;
        var _error = console.error;
        var _warning = console.warning;

        console.error = function (errMessage) {
            // Do something with the error message
            _error.apply(console, arguments);
        };

        console.log = async function (logMessage) {
            // Do something with the log message
            let isObject = false;
            for (let i = 0; i < 5; i++) {
                if (typeof (arguments[i]) == 'object') {
                    isObject = true;
                }
            }
            if (!isObject) {
                await dotnetJSConsole('JsConsole:' + KioskId, arguments[0], arguments[1], arguments[2], arguments[3], arguments[4])
            }
            //if (arguments.length > 0) {
            //    arguments[0] = 'log:' + arguments[0];
            //}
            _log.apply(console, arguments);
        };

        console.warning = function (warnMessage) {
            // do something with the warn message
            _warning.apply(console, arguments);
        };

    })();
    //Then redefine the old console
    console.log('redefine console');
    //window.console = console;
}

async function pcClickPress(event) {
    if (event.keyCode == 13) {
        let pc = document.getElementById('loginPasscode');
        if (pc != null) {
            keylist = pc.value;
            console.log('Input evt got', keylist);
            document.getElementById('loginPasscode').value = '';

            doCollect();
        }
    }
}

function pcfocusInput() {
    //@hf
    //console.log('pcfocusInput')
    let tno = document.getElementById('loginPasscode');
    if (tno != null)
        tno.focus();
    if (focusInputActive) {
        if (pcfocusInputTimerId != null) clearTimeout(pcfocusInputTimerId);
        pcfocusInputTimerId=setTimeout(pcfocusInput, 1000);
    }
}


function keyPad(num) {
//    console.log('keyPad', num)
    let keylist_len;
    let totalNo = 8;
    if (num < 10) {
        if (keylist.length < totalNo)
            keylist += '' + num;
    } else {
        keylist = keylist.substr(0, keylist.length - 1);
    }
    keylist_len = keylist.length;
    if (keylist.length >= totalNo)
        keylist_len = totalNo;
    //console.log(num, keylist, keylist_len);
    for (let i = 1; i <= keylist_len; i++) {
        //@hfttt
//        $('#key' + i).text(keylist[i - 1]);
        document.getElementById("key" + i).innerHTML = keylist[i - 1];
    }
    if (keylist_len >= 0 && keylist_len < totalNo) {
        //console.log('X', keylist_len)
        for (let i = keylist_len + 1; i <= totalNo; i++) {
//            $('#key' + i).text('');
            document.getElementById("key" + i).innerHTML = '';
        }
    }
}

function clearKeyPad() {
    for (let i = 1; i <= 8; i++) {
        let elem = document.getElementById("key" + i);
        if(elem!=null)
            elem.innerHTML = '';
    }
}

function doCollect() {
    doCollect2(CourierPassword);
}

function collectBoxNum(num) {
    console.log('collectBoxNum', num)
}

function doCollectBlink(boxNo) {
    console.log('doCollectBlink...', boxNo);
}

function doCollectRemoveBlink(boxNo) {
    let cb = document.getElementById('collectBlink' + boxNo);
    //console.log('doCollectRemoveBlink', boxNo, cb);
    if (cb != null) {
        //    cb.classList.remove('blinking');
        //cb.style.backgroundColor = 'grey';
        cb.style.backgroundImage = '';
    }

}


//HomePage
function doCountdown() {
    let countDownObj = document.getElementById('Countdown');
    //@hf
    //console.log('CountDown:', CountDown, CurrentPage, OperationMode);

    if (countDownObj != null) {
        countDownObj.style = 'position:absolute;left:78rem;top:37rem;width:12rem;font-size:5rem;color:grey;';

        CountDown--;
        if (CountDown <= 0) {
            countDownObj.innerHTML = '';
        }
        else {
            countDownObj.innerHTML = CountDown;
        }

        if (CountDown > 0) {
            //setTimeout(doCountdown, 1000);
        }
        else {
            if (CurrentPage == 'CollectPage' && OperationMode == 'staffDeliver') {
                goReopenPage();
            }
            else if (CurrentPage == 'ReopenPage') {
                goThankYouPage();
            }
            else if (CurrentPage == 'HomePage') {
                //read temperature
                //    let msg1 = await readSingleDisplayTempSensor(1);
                //    let msg2 = await readSingleDisplayTempSensor(2);
                //    let msg3 = await readSingleDisplayTempSensor(3);

                //do it afer idle 60s
                //console.log('countdown done', CurrentPage, CountDown);
                if (CountDown == -40) {
                    //monitorTemperature();
                }
                if (CountDown == -52) {
                    //monitorControlStatus();
                }
                if (CountDown == -54) {
                    //monitorAlarm();
                }
                if (CountDown <= -60 && CountDown >= -60 - TotalBoxes) {
                    //monitorBoxStatus();
                }

                //repeat afer idle 180s
                if (CountDown <= -900) {
                    console.log('HomePage update server', CountDown);
                    CountDown = 0;
                }
            }
            else if (CurrentPage == 'NonActivePage') {
                console.log('NonActivePage');
            }
            else {
                goHomePage();
            }
        }
    }

    if (countdownTimerId != null) clearTimeout(countdownTimerId);
    countdownTimerId=setTimeout('doCountdown()', 1000);

}

async function monitorTemperature() {
    //let val11 = await readSingleControlTempSensor(1);
    //let val12 = await readSingleControlTempSensor(2);

    //let val21 = await readSingleDefrostTempSensor(1);
    //let val22 = await readSingleDefrostTempSensor(2);

    //let val31 = await readSingleCompressorTempSensor(1);
    //let val32 = await readSingleCompressorTempSensor(2);

    let val41 = await readSingleDisplayTempSensor(1);
    let val42 = await readSingleDisplayTempSensor(2);

    //let val51 = await readSingleLoopTempSensor(1);
    //let val52 = await readSingleLoopTempSensor(2);

    //MonitorData.temperature = `${val11},${val12};${val21},${val22};${val31},${val32};${val41},${val42};${val51},${val52}`;
    MonitorData.temperature = `${val41},${val42}`;
}

async function monitorControlStatus() {
    let val1 = await readSingleStatusTempSensor(1);
    let val2 = await readSingleStatusTempSensor(2);
    MonitorData.control_status = `${val1},${val2}`;
}

async function monitorAlarm() {
    let val1 = await readSingleAlarmTempSensor(1);
    let val2 = await readSingleAlarmTempSensor(2);
    MonitorData.alarm = `${val1},${val2}`;
}

async function monitorBoxStatus() {
    console.log('monitorBoxStatus', CountDown, TotalBoxes, doorAlertIndex, doorAlertCancel);

    if (doorAlertIndex == TotalBoxes) {
        doorAlertIndex = 0;
        let statuslist = [];
        for (let i = 0; i < TotalBoxes; i++) {
            statuslist.push(doorStatus[i]);
        }
        MonitorData.status = statuslist.join(',');
        console.log('monitorBoxStatus complete', MonitorData.status);

        UpdateMonitorData();
    }
    else if (doorAlertIndex < TotalBoxes) {
        await checkDoorAlert();
        doorAlertIndex++;
    }

}

async function checkDoorAlert() {
    await readDoorAlert(doorAlertIndex + 1);

    for (let j = 0; j <= 10; j++) {
        console.log('readAllDoorStatus', csLockControlResponse);
        if (csLockControlResponse != '') break;
        wait(60);
    }
    if (csLockControlResponse.length == 14) {
        let state = csLockControlResponse.substr(8, 2);
        //console.log('state2', state);
        //0:normal
        if (parseInt(state, 16) != 0x00) {
            console.log('checkDoorAlert error');
            doorStatus[doorAlertIndex] = 'malfunction';
        }
        else {
            doorStatus[doorAlertIndex] = '';
        }
    }
    else {
        console.log('checkDoorAlert comm error');
        doorStatus[doorAlertIndex] = 'hw_error';
    }

}

async function ImportNewOrders() {
    let url = `/locker/api/v1/importNewOrders?kiosk_id=${KioskId}`;
    let response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    //    let res = await response.text();

    console.log('ImportNewOrders response', response.ok);

}

async function UpdateMonitorData() {
    //let data = {
    //    kiosk_id: KioskId,
    //    status: status,
    //    temperature: temperature,
    //    controlStatus: controlStatus,
    //    alarm: alarm
    //};
    let response = await fetch('/locker/api/v1/updateMonitorData', {
        method: 'POST',
        body: JSON.stringify(MonitorData),
        headers: {
            'Content-Type': 'application/json'
        },
    });
    //console.log('UpdateMonitorData response', response.ok);

}


async function ___dotnetJSConsole(header, arg1, arg2, arg3, arg4, arg5) {
    try {
        //console.debug(typeof (arg1), typeof (arg2), typeof (arg3), typeof (arg4), typeof (arg5))
        let data = {
            header: header,
            arg1: arg1,
            arg2: arg2,
            arg3: arg3,
            arg4: arg4,
            arg5: arg5,
        };
        let response = await fetch('/locker/api/v1/dotnetJSConsole', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
        });
        //console.log('response', response.ok);
    }
    catch (ex) {
        let xx = 1;
    }
}

function dotnetJSConsole(header, arg1, arg2, arg3, arg4, arg5) {
    const url = `/locker/api/v1/dotnetJSConsole`;
//    let data = `header:${header},${arg1},${arg2},${arg3},${arg4},${arg5}`;    
    let data = {
        header: header,
        arg1: arg1,
        arg2: arg2,
        arg3: arg3,
        arg4: arg4,
        arg5: arg5,
    };

    return new Promise(function (resolve) {
        const xhttp = new XMLHttpRequest();
        xhttp.timeout = 2000;

        xhttp.onreadystatechange = function () {
            console.log('networktest23', this.readyState, this.status);
            if (this.readyState == 4) {  // && this.status == 200
                try {
                    //console.log('responseText', this.responseText, typeof (this.responseText));
                    try {
                        const res = this.responseText;
                        resolve(res);
                    } catch (err) {
                        resolve({ code: -1, msg: 'Network issue7' });
                    }
                } catch (error) {
                    resolve({ code: 1, msg: 'Error! Please retry.' });
                }
            }
        };
        xhttp.open("POST", url);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.send(JSON.stringify(data));
    });
}



function reloadPage() {
    console.log('reloadPage');
    window.location.reload()
}

function renderHello1() {
    console.log('home...')
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { loginPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;
}

function doMyTest1() {
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { collectPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

}

function doMyTest2() {
    //        doOpenBox(num);
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { courierModePage: 'visible' });
    document.getElementById('target').innerHTML = rendered;

    for (let i = 0; i < CourierReservedState.length; i++) {
        CourierReservedState[i] = false;
        CourierExpiredState[i] = false;
    }
    setTimeout(function () { courierInit(); }, 200);
    //await courierInit();
}

function doMyTest3() {
    //let response = await fetch('http:localhost:8000/t1.html', {
    //    method: 'GET',
    //    headers: {
    //        'Content-Type': 'application/json'
    //    },
    //});

    //console.log('response', response);

    window.location.href = 'http://127.0.0.1:12345';
}

function doMyTest4() {
    var template = document.getElementById('homeTemplate').innerHTML;
    var rendered = Mustache.render(template, { reopenPage: 'visible' });
    document.getElementById('target').innerHTML = rendered;
}

function readRefriCommStatusTest() {
    readRefriCommStatus(1);
}

function readBoardCommStatusTest() {
    readBoardCommStatus(1);
}

//0104020018b93a
function doTempTest1() {
    readTempSensor(1, 1);
}

//0104020012393d
function doTempTest2() {
    readTempSensor(1, 2);
}

//0104020024b92b
function doTempTest3() {
    readTempSensor(1, 3);
}

//010402001a38fb
function doTempTest4() {
    //readTempSensor(1, 4);
    readSingleDisplayTempSensor(1)
}

//0104020000b930
function doTempTest5() {
    const start = performance.now();
    console.log('start', start)
    readTempSensor(1, 8);
    const duration = performance.now() - start;
    console.log('dur', duration)
}

function goHotline() {
    console.log('goHotline')
    let img = `/locker/img/${SelectedLang}/hotline.png?rnd=34901162`;
    document.getElementById('hotline').src = img;

    hotlineModal = document.getElementById("hotlineModal");
    hotlineModal.style.display = "block";
    hotlineModalTimer = setTimeout("hotlineModal.style.display = 'none'", 10000);
}

function enableClearAuto() {
    let eca = hotlineModal = document.getElementById("enableClearAuto");
    if (eca != null)
        eca.style.visibility = "visible";
}


function toggleHandicapped() {
    console.log('HandicappedMode*', HandicappedMode);
    let hc = document.getElementById("HandicappedInfo");
    if (hc != null) {
        if (HandicappedMode) {
            hc.style.visibility = "hidden";
            HandicappedMode = false;
        } else {
            hc.style.visibility = "visible";
            HandicappedMode = true;
        }
    }
}

//simple-keyboard
console.log("keyboard start...");

let keyboard;


function init_keyboard() {
    console.log("init_keyboard");
    let Keyboard = window.SimpleKeyboard.default;

    keyboard = new Keyboard({
        onChange: input => onChange(input),
        onKeyPress: button => onKeyPress(button)
    });

    /**
     * Update simple-keyboard when input is changed directly
     */
    document.querySelector(".input").addEventListener("input", event => {
        keyboard.setInput(event.target.value);
    });

    console.log('keyboard',keyboard);
}

function onChange(input) {
    document.querySelector(".input").value = input;
    console.log("Input changed", input);
}

function onKeyPress(button) {
    console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") handleShift();
}

function handleShift() {
    let currentLayout = keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    keyboard.setOptions({
        layoutName: shiftToggle
    });
}


